var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileInstagram = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 48,
  viewBox: "0 0 44 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 24,
  r: 22,
  fill: "url(#paint0_linear_3932_23350)",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.3695 11.1534H13.631C12.4441 11.1546 11.3058 11.6265 10.4664 12.4657C9.62701 13.3049 9.15478 14.4431 9.15332 15.6301V32.3689C9.15478 33.5559 9.62701 34.6938 10.4664 35.5329C11.3058 36.3721 12.4441 36.8441 13.631 36.8452H30.3699C31.5566 36.8438 32.6943 36.3717 33.5335 35.5326C34.3726 34.6934 34.8447 33.5553 34.8462 32.3686V15.6297C34.8447 14.443 34.3726 13.3053 33.5335 12.4661C32.6943 11.627 31.5563 11.1549 30.3695 11.1534ZM13.6313 13.0788H30.3692C31.0457 13.0796 31.6943 13.3487 32.1726 13.827C32.6509 14.3053 32.92 14.9539 32.9207 15.6304V32.3683C32.92 33.0448 32.6509 33.6933 32.1726 34.1717C31.6943 34.65 31.0457 34.9191 30.3692 34.9198H13.6313C12.9547 34.9191 12.306 34.65 11.8275 34.1717C11.3491 33.6934 11.0798 33.0449 11.0787 32.3684V15.6303C11.0798 14.9538 11.3491 14.3053 11.8275 13.827C12.306 13.3487 12.9548 13.0796 13.6313 13.0788ZM29.5018 14.2628C29.2023 14.2628 28.9096 14.3516 28.6606 14.5179C28.4116 14.6843 28.2175 14.9208 28.1029 15.1974C27.9883 15.4741 27.9583 15.7786 28.0168 16.0723C28.0752 16.366 28.2194 16.6358 28.4312 16.8475C28.6429 17.0593 28.9127 17.2035 29.2064 17.2619C29.5001 17.3203 29.8046 17.2903 30.0812 17.1757C30.3579 17.0611 30.5944 16.8671 30.7608 16.6181C30.9271 16.3691 31.0159 16.0763 31.0159 15.7769C31.0159 15.3753 30.8564 14.9902 30.5725 14.7062C30.2885 14.4223 29.9034 14.2628 29.5018 14.2628ZM23.9514 17.561C22.4621 17.1094 20.8622 17.1881 19.4245 17.7837C17.9867 18.3794 16.7999 19.4552 16.0664 20.8279C15.3329 22.2005 15.0981 23.785 15.4019 25.3113C15.7057 26.8377 16.5293 28.2115 17.7325 29.1986C18.9355 30.1856 20.4435 30.725 21.9995 30.7249C22.8833 30.7272 23.7587 30.5542 24.5752 30.2159C25.3916 29.8777 26.1328 29.3809 26.7559 28.7544C27.8562 27.654 28.541 26.2061 28.6935 24.6574C28.846 23.1086 28.4567 21.5548 27.5921 20.2608C26.7274 18.9668 25.4407 18.0127 23.9514 17.561ZM19.3333 20.008C20.1226 19.4806 21.0506 19.1991 21.9999 19.199C23.2726 19.2005 24.4927 19.7068 25.3927 20.6068C26.2926 21.5067 26.7989 22.7269 26.8004 23.9996C26.8004 24.9489 26.5189 25.8768 25.9915 26.6661C25.464 27.4555 24.7143 28.0708 23.8372 28.4341C22.96 28.7974 21.9949 28.8925 21.0637 28.7072C20.1326 28.522 19.2772 28.0648 18.6059 27.3935C17.9346 26.7222 17.4774 25.8669 17.2922 24.9357C17.107 24.0046 17.202 23.0394 17.5654 22.1623C17.9287 21.2851 18.5439 20.5354 19.3333 20.008Z",
  fill: "url(#paint1_linear_3932_23350)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3932_23350",
  x1: 0,
  y1: 24,
  x2: 44,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAA745"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#D20A5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#CF0963"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#C4076E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#B30382"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8008E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3932_23350",
  x1: 9.15332,
  y1: 23.9993,
  x2: 34.8462,
  y2: 23.9993,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAA745"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#D20A5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#CF0963"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#C4076E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#B30382"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8008E"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileInstagram);
export default ForwardRef;